import Shared from "emun.cart/cart.controller";
import resolve from "ioc/resolve";
import templateUrl from "emun.cart/aptean/cart-creditcard-aptean.htm";
import AutoQuery from "servicestack/auto-query/auto-query.es6";
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";
import cartConfig from "emun.cart/cart.config";

export class CartCreditCardApteanController extends Shared {
	constructor($cart, $sce) {
		super($cart, $sce);
		let $rootScope = resolve("$rootScope");
		let $stateParams = resolve("$stateParams");
		let $session = resolve("$session");
		if ($stateParams.cartId) $cart.load($stateParams.cartId);
		let $ctrl = this;
		$ctrl.paymentMethod = {
			name: $ctrl.$cart.buyer,
			address: $ctrl.$cart.purchaser.address,
			address2: $ctrl.$cart.purchaser.address2,
			city: $ctrl.$cart.purchaser.city,
			state: $ctrl.$cart.purchaser.state,
			zip: $ctrl.$cart.purchaser.zip,
			country: $ctrl.$cart.purchaser.country.toUpperCase() == "UNITED STATES" ? "US" : $ctrl.$cart.purchaser.country.toUpperCase() == "CANADA" ? "CA" : $ctrl.$cart.purchaser.country,
		};
		$ctrl.bus = new ServiceBus;
		$ctrl.cartConfig = cartConfig;
		let retailerId = $ctrl.retailerId || $ctrl.$cart.retailerId;

		// var apiKey = '70e403b098e247efb8774d40a63d3d1b';
		// var productID = 'e0683da0-d6a8-4122-ac68-0630f50dc1b8';
		// var tenantID = 'ae97f471-5063-4e03-ade5-ac2814fc2f6e';
		// var accountID = '86d9444f-0c1c-4f42-b8bd-d833ef7f49a2';

		var apiKey = $session.meta.ApteanApiKey;
		var productID = $session.meta.ApteanProductId;
		var tenantID = $session.meta.ApteanTenantId;
		var accountID = $session.meta.ApteanAccountId;
  
		// initialize Aptean Pay
		const apteanPay = ApteanPay( apiKey, productID, tenantID);
  
		// create builder objects
		const components = apteanPay.components({});
		const cardComponent = components.create('card', {});
  
		// mount the form to the DOM
		cardComponent.mount(
		  'capture', // containerId
		  '#buttonTrigger' // triggerQuerySelector
		);
  
		// this method returns a callback function.
		// todo: requires card holder's address infrmation -- prompt using input fields
		apteanPay.createClaim(
		  cardComponent,
		  {
			name: $ctrl.paymentMethod.name,
			addressLine1: $ctrl.paymentMethod.address,
			addressLine2: $ctrl.paymentMethod.address2,
			addressCity: $ctrl.paymentMethod.city,
			addressState: $ctrl.paymentMethod.state,
			addressZip: $ctrl.paymentMethod.zip,
			addressCountry: $ctrl.paymentMethod.country,
			emailAddress: $ctrl.$cart.purchaser.email,
			recurring: false,
			phoneCountryCode: '+1',
			phoneNumber: $ctrl.$cart.billingLocation.phone ? $ctrl.$cart.billingLocation.phone.replace(/\D/g,'') : ""
		  },
		  {
			accountId: accountID,
			//expirationDate: new Date().setMonth(new Date().getMonth() + 1), // optional
			singleUse: false, // optional
		  },
		  function(paymentMethodClaim, error) {
			// error object
			if (error) {
			  console.debug("BL*** aptean error", error[0].message);
			  modals.alert(error[0].message);
			}
  
			// payment method claim object; id property holds the claim token
			var token = paymentMethodClaim;
			if (token) {
			   console.log(JSON.stringify(token));
				$ctrl.paymentMethod = {
					name: $ctrl.$cart.buyer || $ctrl.$cart.purchaser.companyName,
					address: $ctrl.$cart.purchaser.address || $ctrl.$cart.billingLocation.address,
					address2: $ctrl.$cart.purchaser.address2 || $ctrl.$cart.billingLocation.address2,
					city: $ctrl.$cart.purchaser.city || $ctrl.$cart.billingLocation.city,
					state: $ctrl.$cart.purchaser.state || $ctrl.$cart.billingLocation.state,
					zip: $ctrl.$cart.purchaser.zip || $ctrl.$cart.billingLocation.zip,
					country: $ctrl.$cart.purchaser.country.toUpperCase() == "UNITED STATES" ? "US" : $ctrl.$cart.purchaser.country.toUpperCase() == "CANADA" ? "CA" : $ctrl.$cart.purchaser.country,
				};
			   $ctrl.paymentMethod.isPrimary = true;
			   $ctrl.paymentMethod.tokenizationCode = token.id;
			   $ctrl.paymentMethod.tokenizationProvider = "Aptean";
			   $ctrl.paymentMethod.number = "TOKEN";
			   $ctrl.paymentMethod.type = token.cardInfo.cardBrand;
			   $ctrl.paymentMethod.network = token.cardInfo.cardBrand;
			   $ctrl.paymentMethod.provider = token.cardInfo.cardBrand;
			   $ctrl.paymentMethod.lastFour = token.cardInfo.lastFour;
			   $ctrl.paymentMethod.expirationMonth = token.cardInfo.expirationMonth;
			   $ctrl.paymentMethod.expirationYear = token.cardInfo.expirationYear;
			   $ctrl.paymentMethod.retailerId =
				   $ctrl.$cart.purchaser.id || $ctrl.$cart.retailerId;
			   $ctrl.paymentMethod.expiration =
				   $ctrl.paymentMethod.expirationMonth + $ctrl.paymentMethod.expirationYear;
			   $ctrl.paymentMethod.expiresOn =
				   $ctrl.paymentMethod.expirationMonth +
				   "/1/" +
				   $ctrl.paymentMethod.expirationYear;
			   $ctrl.paymentMethod.cartId = $ctrl.$cart.id;
			   console.debug(
				   "$ctrl.$cart.errorToastFactory",
				   $ctrl.$cart.errorToastFactory
			   );
			   $ctrl.$cart.bus
				   .send(
					   "CreateRetailerPaymentMethod.json",
					   $ctrl.paymentMethod
				   )
				   .then(function (response) {
					   //$ctrl.$cart.applyPaymentMethod(response, $ctrl.$cart.id);
					   $ctrl.newCardID = token.id;
					   $rootScope.$broadcast("creditCardCreated", token);
				   }, $ctrl.$cart.errorToastFactory("saveCardFailed"));
	   
			}
		  }
		);
	}
	toggleSameAsCorporate() {
		let $ctrl = this;
		if ($ctrl.sameAsCorporate) {
			$ctrl.paymentMethod.address =
				$ctrl.$cart.purchaser.address || $ctrl.$cart.billingLocation.address;
			$ctrl.paymentMethod.address2 =
				$ctrl.$cart.purchaser.address2 || $ctrl.$cart.billingLocation.address2;
			$ctrl.paymentMethod.city =
				$ctrl.$cart.purchaser.city || $ctrl.$cart.billingLocation.city;
			$ctrl.paymentMethod.state =
				$ctrl.$cart.purchaser.state || $ctrl.$cart.billingLocation.state;
			$ctrl.paymentMethod.zip =
				$ctrl.$cart.purchaser.zip || $ctrl.$cart.billingLocation.zip;
			$ctrl.paymentMethod.country =
				$ctrl.$cart.purchaser.country || $ctrl.$cart.billingLocation.country;
		}
	}
}

export default {
	bindings: {
		retailerId: "@",
		returnUri: "@"
	},
	controller: CartCreditCardApteanController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};
